import { CacheInternalRecord, TolgeeProvider, TolgeeStaticData } from '@tolgee/react';
import { tolgee } from '../index';
import React, { useEffect } from 'react';

type Props = {
  language: string;
  staticData: TolgeeStaticData | CacheInternalRecord[];
  children: React.ReactNode;
};

export const TolgeeNextProvider = ({ language, staticData, children }: Props) => {
  // const router = useNavigate();
  useEffect(() => {
    // this ensures server components refresh, after translation change
    const { unsubscribe } = tolgee.on('permanentChange', () => {
      console.log('TolgeeNextProvider >>> Upgraded translation!');
      // router('.');
    });
    return () => unsubscribe();
  }, [tolgee]);
  return (
    <TolgeeProvider tolgee={tolgee} fallback='Loading...' ssr={{ language, staticData }}>
      {children}
    </TolgeeProvider>
  );
};
